import { useState } from 'react';
import queryString from 'query-string';
import { AuthenticationService } from '@knockrentals/knock-react';
import LoginAPI from './LoginAPI';
import {
  deleteAccessTokenCookie,
  getCookie,
  getRoleFromToken,
  handleError,
  isUserRoleValid,
} from './utils';
import { ACCESS_TOKEN_LOGIN_TYPE, QUERY_STRING_PARAMS } from '../../constants';

const useLogin = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [knockAccessToken, setKnockAccessToken] = useState('');

  const locationSearchString = () => history.location.search;

  const handleKnockLogin = async ({ username, password }) => {
    setLoading(true);

    try {
      const { accessToken, refreshToken } = await LoginAPI.login(
        username,
        password
      );

      const role = getRoleFromToken(accessToken);
      isUserRoleValid(role);

      AuthenticationService.setToken(accessToken);
      AuthenticationService.setRefreshToken(refreshToken);
      window.location.reload();
    } catch (error) {
      const { message } = error || {};
      handleError(message, username);
    }

    setLoading(false);
  };

  const handleKnockAccessTokenLogin = async () => {
    setLoading(true);
    AuthenticationService.clearRefreshToken();

    try {
      const role = getRoleFromToken(knockAccessToken);
      isUserRoleValid(role);

      const { accessToken, refreshToken } = await LoginAPI.getUserRefreshToken(
        knockAccessToken
      );

      AuthenticationService.setToken(accessToken);
      AuthenticationService.setRefreshToken(refreshToken);
      window.location.reload();
    } catch (error) {
      const { message } = error || {};
      setKnockAccessToken('');
      handleError(message);
      setLoading(false);
    }
  };

  const removeQueryString = () => {
    history.replace({ search: '' });
  };

  const handleParsedKnockToken = (parsedKnockToken) => {
    deleteAccessTokenCookie(window.location.hostname);
    removeQueryString();
    AuthenticationService.clearToken();
    setKnockAccessToken(parsedKnockToken);
  };

  const handleCookieAccess = () => {
    const knockCookieAccessToken = getCookie('accessToken');
    if (knockCookieAccessToken) {
      handleParsedKnockToken(knockCookieAccessToken);
    }
  };

  const handleContingentAccessToken = () => {
    const queryParams = queryString.parse(locationSearchString());
    const knockQueryAccessToken = queryParams[QUERY_STRING_PARAMS.ACCESS_TOKEN];

    if (knockQueryAccessToken) {
      const accessTokenLoginType = queryParams[QUERY_STRING_PARAMS.LOGIN_TYPE];

      accessTokenLoginType
        ? localStorage.setItem(ACCESS_TOKEN_LOGIN_TYPE, accessTokenLoginType)
        : localStorage.removeItem(ACCESS_TOKEN_LOGIN_TYPE);

      handleParsedKnockToken(knockQueryAccessToken);
      return;
    }

    handleCookieAccess();
  };

  return {
    handleContingentAccessToken,
    handleKnockAccessTokenLogin,
    handleKnockLogin,
    knockAccessToken,
    loading,
  };
};

export default useLogin;
